import React from 'react';
import Section from './Section';

const Contact = () => {
  return (
    <Section id="contact">
      <div className="max-w-xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-3xl font-bold tracking-tight mb-3 text-zinc-950">Questions?</h2>
          <p className="text-zinc-600">Reach out anytime. We're here to help.</p>
        </div>
        
        <form 
          action="https://formspree.io/f/myklzeaw" 
          method="POST"
          className="space-y-4"
        >
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label htmlFor="name" className="block text-sm font-medium text-zinc-700 mb-1">Name</label>
              <input 
                type="text" 
                id="name" 
                name="name"
                required
                className="w-full px-4 py-3 rounded-lg border border-zinc-300 bg-white focus:ring-2 focus:ring-zinc-900 focus:border-zinc-900 outline-none transition-all"
                placeholder="Jane Doe"
              />
            </div>
            <div>
              <label htmlFor="email" className="block text-sm font-medium text-zinc-700 mb-1">Email</label>
              <input 
                type="email" 
                id="email" 
                name="email"
                required
                className="w-full px-4 py-3 rounded-lg border border-zinc-300 bg-white focus:ring-2 focus:ring-zinc-900 focus:border-zinc-900 outline-none transition-all"
                placeholder="jane@example.com"
              />
            </div>
          </div>
          <div>
            <label htmlFor="message" className="block text-sm font-medium text-zinc-700 mb-1">Message (Optional)</label>
            <textarea 
              id="message" 
              name="message"
              rows="4" 
              className="w-full px-4 py-3 rounded-lg border border-zinc-300 bg-white focus:ring-2 focus:ring-zinc-900 focus:border-zinc-900 outline-none transition-all resize-none"
              placeholder="How can we help?"
            ></textarea>
          </div>
          <button 
            type="submit" 
            className="w-full py-4 bg-zinc-950 text-white font-bold rounded-lg hover:bg-zinc-800 transition-all shadow-lg shadow-zinc-900/10 active:scale-[0.98]"
          >
            Send Message
          </button>
          <p className="text-center text-xs text-zinc-400 mt-4">
            By sending a message, you agree to our privacy policy.
          </p>
        </form>
      </div>
    </Section>
  );
};

export default Contact;